import { normalizeCode } from './billingLabels';

type PrimeSeverity = 'success' | 'warn' | 'danger' | 'info' | 'secondary' | 'contrast'

const statusMap: Record<string, PrimeSeverity> = {
  active: 'success',
  accepted: 'success',
  approved: 'success',
  completed: 'success',
  paid: 'success',
  successful: 'success',
  sent: 'success',
  endorsed: 'success',
  hod_endorsed: 'success',

  converted: 'info',
  published: 'info',
  in_progress: 'info',
  unpaid: 'info',
  level_adviser_approved: 'info',
  uploaded: 'info',

  pending: 'warn',
  processing: 'warn',
  partial: 'warn',
  partially_paid: 'warn',
  under_review: 'warn',
  edited: 'warn',

  rejected: 'danger',
  failed: 'danger',
  overdue: 'danger',
  cancelled: 'danger',

  withdrawn: 'secondary',
  draft: 'secondary',

  void: 'contrast',
  voided: 'contrast',
  refunded: 'secondary',
  partially_refunded: 'warn',
  revoked: 'secondary',
  processed: 'success',
};

export function getStatusSeverity(status: string | undefined | null): PrimeSeverity {
  if (!status) return 'info';
  // normalizeCode: the API sends PHP case names ('PartiallyPaid'), which a
  // plain toLowerCase() turns into 'partiallypaid' and misses the map.
  return statusMap[normalizeCode(status)] ?? statusMap[status.toLowerCase()] ?? 'info';
}
